"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncMultiCurrencyTab;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var MultiCurrencyTab = (0, _Loadable.default)({
  loader: function loader() {
    return import('./MultiCurrencyTab'
    /* webpackChunkName: "chunk-account-defaults" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncMultiCurrencyTab(props) {
  return _react.default.createElement(MultiCurrencyTab, props);
}

module.exports = exports.default;